import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../data.service';
@Component({
  selector: 'lc-anon-shop-page',
  templateUrl: './anon-shop-page.component.html',
  styleUrls: ['./anon-shop-page.component.scss']
})
export class AnonShopPageComponent implements OnInit {

  constructor(public dataService: DataService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
     //console.log(this.router.url);
    if( this.router.url.indexOf('commande') > -1) {
        this.dataService.set_language('fr');
    }
    console.log(this.dataService.user_info);

  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/anon-shop-page/anon-shop-page.component.ts